import { render, staticRenderFns } from "./SpecimenStatusTracking.vue?vue&type=template&id=4be40537"
import script from "./SpecimenStatusTracking.vue?vue&type=script&lang=js"
export * from "./SpecimenStatusTracking.vue?vue&type=script&lang=js"
import style0 from "./SpecimenStatusTracking.vue?vue&type=style&index=0&id=4be40537&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports